import { Alert } from '@designsforhealth/dfh-react-components'
import React, { FC } from 'react'
import styled from 'styled-components'

import { usePractitionerSettings } from '../../../../lib/practitioner-settings/hooks/usePractitionerSettings'
import Spacer from '../../../Spacer'
import Spinner from '../../../Spinner'
import DispensingOptionsSection from './practitioner/dispensing-options/DispensingOptionsSection'

const Container = styled.div`
  @media (min-width: 768px) {
    max-width: 688px;
    padding-left: 47px;
    h3 {
      max-width: 350px;
    }
  }
`

const StyledHeader = styled.h2`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 24px;
  color: #001b36;
  margin-bottom: 8px;
`

const StyledDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
  }
  font-size: 16px;
  color: #001b36;
  margin-bottom: 0;
  line-height: 1.19;
`

const DispensingOptionsContainer: FC = () => {
  const [settings, { loading, error, called }] = usePractitionerSettings()

  if (!called || loading) {
    return <Spinner loading />
  }

  if (error || !settings) {
    return (
      <Alert type="error">
        We were unable to load your practitioner settings, please try again soon.
      </Alert>
    )
  }

  return (
    <Container>
      <StyledHeader>Dispensing options</StyledHeader>
      <StyledDescription>
        Unlock exclusive discounts and rebates with our tailored solutions. Manage your dispensing
        more efficiently than ever and maximize your earning potential.
      </StyledDescription>
      <Spacer size={4} />
      <DispensingOptionsSection settings={settings} />
    </Container>
  )
}

DispensingOptionsContainer.defaultProps = {}

DispensingOptionsContainer.propTypes = {}

export default DispensingOptionsContainer
